import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { normalize } from '../utils';
import { union } from 'lodash';

const resource = (state, { type, payload }) => {
  switch (type) {
    case 'EMPLOYEE_RESOURCE_REQUEST':
      return {
        ...state,
        ...payload,
        loading: true,
      };
    case 'EMPLOYEE_RESOURCE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_CREATE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state, // Not sure if I should leave the old state here
        ...payload,
        loading: false,
      };
    default:
      return state;
  }
};

const byId = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'PAY_RATE_UPLOADS_FILE_UPLOAD_SUCCESS':
    case 'PAY_RATE_UPLOADS_LIST_REQUEST_SUCCESS': {
      return Object.assign({}, state, payload.entities && payload.entities.employees);
    }
    case 'EMPLOYEE_RESOURCE_REQUEST':
    case 'EMPLOYEE_RESOURCE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_CREATE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_UPDATE_SUCCESS':
      return {
        ...state,
        [payload.id]: resource(state[payload.id], action),
      };
    case 'EMPLOYEE_LIST_SUCCESS':
      // Test if it is not an overkill, assign always from a new object
      return Object.assign({}, state, normalize(payload.employees));
    case 'ADD_EVENT_TO_EMPLOYEE_SUCCESS': {
      const clonedState = Object.assign({}, state);
      clonedState[payload.employeeId] = {
        ...clonedState[payload.employeeId],
        events: 'events' in state[payload.employeeId] ? [payload.event, ...state[payload.employeeId].events] : [payload.event],
      };
      return clonedState;
    }
    case 'ADD_EVENT_TO_EMPLOYEE_FAILURE':
    default:
      return state;
  }
};

const defaultFilters = {
  data: {
    is_active: true,
    for_workrooms: [],
    is_pending: null,
    for_roles: [],
    query: null,
  },
  idsByFilter: [], // keys will be generated when the data arrives
};

const filters = (state = defaultFilters, { type, payload }) => {
  switch (type) {
    case 'EMPLOYEE_LIST_SUCCESS': {
      return {
        ...state,
        idsByFilter: union(state.idsByFilter || [], payload.employees.map(item => item.id)),
      };
    }
    case 'EMPLOYEE_SET_FILTER': {
      return {
        ...state,
        data: Object.assign({}, payload),
      };
    }
    case 'EMPLOYEE_RESET_FILTERS':
      return defaultFilters;
    // When a user is created/updated the easiest behaviour is to reset pagination
    // so the filters are properly updated in the listing screen
    case 'EMPLOYEE_RESOURCE_CREATE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_UPDATE_SUCCESS':
    case 'EMPLOYEE_RESET_PAGINATION': {
      return {
        ...state,
        idsByFilter: [],
      };
    }
    default:
      return state;
  }
};

const initialState = {
  loading: false,
  errors: {},
  page: 1,
  hasNextPage: true,
};

const common = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'EMPLOYEE_LIST_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'EMPLOYEE_RESOURCE_CREATE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_UPDATE_SUCCESS':
    case 'EMPLOYEE_RESET_PAGINATION':
      return {
        ...state,
        page: 1,
        hasNextPage: true,
      };
    case 'EMPLOYEE_LIST_SUCCESS':
      return {
        ...state,
        loading: false,
        page: state.page + 1,
        hasNextPage: payload.has_next_page,
      };
    case 'EMPLOYEE_LIST_FAILURE':
    case 'EMPLOYEE_RESOURCE_CREATE_FAILURE':
    case 'EMPLOYEE_RESOURCE_UPDATE_FAILURE':
    case 'EMPLOYEE_RESOURCE_SYNC_VALIDATION_FAILURE':
      return {
        ...state,
        loading: false,
        errors: payload.errors,
      };
    case 'EMPLOYEE_RESOURCE_REQUEST':
    case 'EMPLOYEE_RESOURCE_SUCCESS':
    case 'EMPLOYEE_RESOURCE_CLEAR_VALIDATION':
      return {
        ...state,
        errors: {},
      };
    default:
      return state;
  }
};

export default combineReducers({
  byId,
  common,
  filters,
});

const getById = state => state.byId;
const getHasNextPage = state => state.common.hasNextPage;
const getPage = state => state.common.page;
const getLoading = state => state.common.loading;
const getVisibleFilter = state => state.filters.data.status;
const getFiltersData = state => state.filters.data;
const idsByFilter = state => state.filters.idsByFilter;
const getErrors = state => state.common.errors;

const getList = createSelector(
  getById,
  idsByFilter,
  (lookup, list) => list.map(id => lookup[id]),
);

const getInactiveVisible = createSelector(
  getVisibleFilter,
  status => status === 'all',
);

export {
  getList,
  getHasNextPage,
  getPage,
  getLoading,
  getErrors,
  getById,
  getInactiveVisible,
  getFiltersData,
};



// WEBPACK FOOTER //
// ./client/app/reducers/employees.js